import { render, staticRenderFns } from "./PopDiscount.vue?vue&type=template&id=1d84e37d&scoped=true&"
import script from "./PopDiscount.vue?vue&type=script&lang=js&"
export * from "./PopDiscount.vue?vue&type=script&lang=js&"
import style0 from "./PopDiscount.vue?vue&type=style&index=0&id=1d84e37d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84e37d",
  null
  
)

export default component.exports